import LowPriorityIcon from '@mui/icons-material/LowPriority';
import WorkflowList from './WorkflowList';

export default {
  icon: LowPriorityIcon,
  list: WorkflowList,
};
